import React from 'react';
import {
  Dialog, DialogClose, DialogContent, DialogTitle,
} from '../../../components/base/Dialog/Dialog';

import MobileCamerasItem from './MobileCamerasItem';

export default function MobileCamerasPopup(props) {
  const { handleClose = () => {}, item } = props;
  if (!item) {
    return null;
  }
  return (
    <Dialog
      onClose={handleClose}
      open
      className="parking-meter-popup"
      size="xl"
    >
      <DialogContent>
        <MobileCamerasItem item={item} handleClose={handleClose} />
      </DialogContent>
    </Dialog>
  );
}
